module.exports = __webpack_public_path__ + "img/syukyaku-kyu-001.7c74996d.jpg";